function loadCanvas() {
  $('canvas.logo').each(function () {
    const canvas = this;
    const ctx = canvas.getContext('2d');
    const image = new Image();
    let lightX = -150;

    // Lấy đường dẫn ảnh từ thuộc tính data-src
    const src = $(canvas).attr('data-src');
    $(image).on('load', function () {
      canvas.width = image.width;
      canvas.height = image.height;
      draw();
    }).attr('src', src);

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0);

      const gradient = ctx.createLinearGradient(lightX - 100, 0, lightX + 100, 0);
      gradient.addColorStop(0, 'rgba(255, 255, 255, 0)');
      gradient.addColorStop(0.4, 'rgba(255, 255, 255, 0.5)');
      gradient.addColorStop(0.5, 'rgba(255, 255, 255, 0.8)');
      gradient.addColorStop(0.6, 'rgba(255, 255, 255, 0.5)');
      gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');

      ctx.globalCompositeOperation = 'source-atop';
      ctx.fillStyle = gradient;
      ctx.fillRect(lightX - 100, 0, 200, canvas.height);
      ctx.globalCompositeOperation = 'source-over';

      lightX += 5;
      if (lightX - 100 > canvas.width) lightX = -150;
      requestAnimationFrame(draw);
    }
  });
}

window.addEventListener("load", function () {
  loadCanvas();
});